const BASE_CLASSES = 'menu-item';
const menuItems = [
  {
    id: 1,
    classes: BASE_CLASSES,
    content: 'sobre',
    title: 'Acerca de',
  },
  {
    id: 2,
    classes: BASE_CLASSES,
    content: 'semblanzas',
    title: 'Semblanzas Entrevistados',
  },
  {
    id: 3,
    classes: BASE_CLASSES,
    content: 'creditos',
    title: 'Créditos',
  },
  {
    id: 4,
    classes: BASE_CLASSES,
    content: 'pelicula',
    title: 'Película',
  },
  {
    id: 5,
    classes: BASE_CLASSES,
    content: 'exposicion',
    title: 'Exposición',
  },
];
export default menuItems;
